<template>
<article>
  <section id="salon_page_main">
    <div class="content_wrap">

      <div class="salon_box">
        <figure v-if="this.rawData.image !== undefined && this.rawData.image !== null">
          <img :src="'/storage/customers/' + this.rawData.image" alt />
        </figure>
        <figure v-else>
          <img src="/assets/img/common/no_image.png" alt="No Image" />
        </figure>
        <table class="salon_info">
          <tbody>
            <tr>
              <td colspan="2">
                <h1 class="salon_title">
                  <span class="area">{{this.rawData.prefName}}</span>
                  {{this.rawData.juristic_name}}
                </h1>
              </td>
            </tr>
            <tr>
              <th>住所</th>
              <td>
                <span>{{this.rawData.prefName}}</span>
                <span>{{this.rawData.address1}}</span>
                <span>{{this.rawData.address2}}</span>
                <span>{{this.rawData.address3}}</span>
              </td>
            </tr>
            <tr>
              <th>TEL</th>
              <td><a :href="'tel:' + this.rawData.tel">{{this.rawData.tel}}</a></td>
            </tr>
            <tr>
              <th>FAX</th>
              <td>{{this.rawData.fax}}</td>
            </tr>
            <tr>
              <th>HP</th>
              <td>
                <a v-bind:href="this.rawData.site_url" target="_blank">{{this.rawData.site_url}}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
  <!-- /#salon_page_main -->
  <posts-archive-component hashtag="JNA" :item-name="this.salonTypeName" :item-type="'最新情報'" :user-id="Number(this.salonId)" :limit="12" ref="child1">
  </posts-archive-component>
  <posts-archive-component hashtag="求人" :item-name="this.salonTypeName" :item-type="'求人情報'" :user-id="Number(this.salonId)" :limit="12" ref="child2">
  </posts-archive-component>
</article>
</template>

<script>
export default {
  props:{
    salonId: Number
  },
  data() {
    return {
      salonTypeName: "認定ネイルサロンの",
      rawData: []
    };
  },
  methods: {
    getPost() {
      var self = this;
      axios
        .post("/api/customers/" + String(this.salonId))
        .then(response => {
            // handle success(axiosの処理が成功した場合に処理させたいことを記述)
            self.rawData = response.data;
            var rawData = self.rawData;
            var prefData = self.prefs
              .filter(function(object) {
                return object.id == rawData.pref;
              })
              .shift();
            
            self.rawData.prefName = 
              (prefData !== undefined && 'name' in prefData) ?
              prefData.name :
              '';
            
            self.$refs.child1.dataUpdate(response.data.customer_type);
            self.$refs.child2.dataUpdate(response.data.customer_type);
        })
        .catch(function(error) {
          // handle error(axiosの処理にエラーが発生した場合に処理させたいことを記述)
          console.log(error);
        })
        .finally(function() {
          // always executed(axiosの処理結果によらずいつも実行させたい処理を記述)
        });
    }
  },
  created() {
    this.getPost();
  }/*,
  updated() {
    console.log(this.rawData.customer_type);
    if (this.rawData.customer_type == "school"){
      this.salonTypeName = "認定校の";
    } else if (this.rawData.customer_type == "corporate") {
      this.salonTypeName = "";
    }
  }*/
};
</script>